<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <h1 slot="title" class="mt-2 text-uppercase text-left font-weight-bold">Ingreso guía de despacho</h1>
      <b-row>
        <b-col cols="12">
          <b-card no-body>
            <form-wizard
              color="#0074d9"
              shape="circle"
              stepSize="sm"
              errorColor="#ff4136"
              ref="wizard"
              title=""
              subtitle=""
              next-button-text="Siguiente"
              back-button-text="Atrás"
              finish-button-text="Terminar"
              @on-complete="submitWaybill"
            >
              <wizard-step
                slot-scope="props"
                slot="step"
                :tab="props.tab"
                :transition="props.transition"
                :index="props.index"
              ></wizard-step>

              <tab-content title="Información del documento" :before-change="submitWaybill">
                <b-row>
                  <b-col sm="12">
                    <b-button variant="secondary" class="pull-right" @click="showModalExtraInfo = !showModalExtraInfo"
                      >Información extra</b-button
                    >
                  </b-col>

                  <b-col sm="6">
                    <b-form-group description label="Exportadora">
                      <b-form-select
                        v-model="waybillData.client_customer"
                        :state="$v.waybillData.client_customer.$dirty ? !$v.waybillData.client_customer.$error : null"
                        aria-describedby="input-exportadora-live-feedback"
                      >
                        <option value>Seleccione</option>
                        <option
                          v-for="customer in customers"
                          v-bind:value="{ id: customer.value, text: customer.text }"
                        >
                          {{ customer.text }}
                        </option>
                      </b-form-select>
                      <b-form-invalid-feedback id="input-exportadora-live-feedback">
                        <p>Exportadora es requerido</p>
                      </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-group description label="Planta que despacha">
                      <b-form-select
                        v-model="$v.waybillData.plant.$model"
                        :state="$v.waybillData.plant.$dirty ? !$v.waybillData.plant.$error : null"
                        aria-describedby="input-exportadora-live-feedback"
                        :options="plantOptions"
                      >
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col sm="6">
                    <b-form-group description label="Empresa destino">
                      <b-form-select
                        v-model="waybillData.recipient_company"
                        :state="
                          $v.waybillData.recipient_company.$dirty ? !$v.waybillData.recipient_company.$error : null
                        "
                        :options="companies"
                        aria-describedby="input-empresa-live-feedback"
                      >
                      </b-form-select>
                      <b-form-invalid-feedback id="input-exportadora-live-feedback">
                        <p>Empresa es requerido</p>
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                  <b-col sm="6">
                    <b-form-group>
                      <label for>Número de guía</label>
                      <b-form-input
                        type="text"
                        v-model="waybillData.numero_guia"
                        :state="$v.waybillData.numero_guia.$dirty ? !$v.waybillData.numero_guia.$error : null"
                        aria-describedby="input-numeroguia-live-feedback"
                        placeholder="Ingrese sólo números"
                      ></b-form-input>
                      <b-form-invalid-feedback id="input-numeroguia-live-feedback">
                        <p v-if="!$v.waybillData.numero_guia.required">Número de guia es requerido</p>
                        <p v-if="!$v.waybillData.numero_guia.numeric">Solo numeros</p>
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>

                  <b-col sm="6">
                    <b-form-group label="Fecha de guía">
                      <b-form-datepicker
                        placeholder="dd-mm-aaaa"
                        locale="es"
                        v-model="waybillData.waybill_date"
                        :state="$v.waybillData.waybill_date.$dirty ? !$v.waybillData.waybill_date.$error : null"
                      ></b-form-datepicker>
                    </b-form-group>
                  </b-col>

                  <b-col sm="6">
                    <b-form-group description label="Nombre del Chofer">
                      <b-form-input
                        type="text"
                        v-model="waybillData.truck_driver"
                        :state="$v.waybillData.truck_driver.$dirty ? !$v.waybillData.truck_driver.$error : null"
                        aria-describedby="input-nombrechofer-live-feedback"
                      />

                      <b-form-invalid-feedback id="input-nombrechofer-live-feedback">
                        <p>Nombre del Chofer es requerido</p>
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>

                  <b-col sm="6">
                    <b-form-group description label="Patente">
                      <b-form-input
                        type="text"
                        v-model="waybillData.license_plate"
                        :state="$v.waybillData.license_plate.$dirty ? !$v.waybillData.license_plate.$error : null"
                        aria-describedby="input-patente-live-feedback"
                        placeholder
                      />

                      <b-form-invalid-feedback id="input-patente-live-feedback">
                        <p>Nombre del Chofer es requerido</p>
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>

                  <b-col sm="12">
                    <b-form-group description label="Nota">
                      <b-form-textarea id="basicTextarea" :textarea="true" v-model="waybillData.note" type="text" />
                    </b-form-group>
                  </b-col>
                </b-row>
              </tab-content>

              <tab-content title="Ingresar Pallets" :before-change="tapSiguiente">
                <span>
                  <barcode-scanner
                    :waybill_id="waybillData.id"
                    :client_customer="waybillData.client_customer"
                    @addPalletswaybill="addPalletswaybill($event)"
                  >
                  </barcode-scanner>
                  <span class="float-right"> <select-scale size="md"></select-scale></span>
                  <b-input-group-append>
                    <AddPalletsGuia
                      ref="addpallet"
                      :waybill_id="waybillData.id"
                      :waybill_numero="waybillData.numero_guia"
                      :client_customer="waybillData.client_customer"
                      :tableDataPalletStock="tableDataPalletStock"
                      @addPalletswaybill="addPalletswaybill($event)"
                    >
                    </AddPalletsGuia>
                  </b-input-group-append>
                  <detail
                    v-if="waybillData.id"
                    :table-data="items"
                    :fields="fields"
                    small
                    caption="Detalle de guía de despacho"
                    @deletePallet="excludePallet($event)"
                  ></detail>
                </span>
              </tab-content>

              <tab-content title="Imprimir Despacho" :before-change="tapTerminar">
                <report v-if="waybill" ref="report" :waybill="waybill"></report>
              </tab-content>
            </form-wizard>
          </b-card>
        </b-col>
      </b-row>
    </div>

    <ExtraInfoWaybill
      :visible="showModalExtraInfo"
      @close="showModalExtraInfo = false"
      :extraInfoWaybillObj="extraInfoWaybillObj"
    />
  </div>
</template>

<script>
// TODO: Cuando me dirijo a Ingreso desde editar guia, no refresca la pagina ingreso.
// TODO: El boton de NExt debe permanecer inactiva hasta qeu se rellenen los datos obligatorios.
// TODO: Pantalla de finalización del proceso con opcion de imprimir, enviar x correo, etc.
// TODO: Comportamiento de modales; a veces se quedan pegados.

import { shuffleArray } from "@/shared/utils";

import { validationMixin } from "vuelidate";

import { required, numeric } from "vuelidate/lib/validators";

import AddPalletsGuia from "./AddPalletsGuia.vue";
import BarcodeScanner from "./BarcodeScanner.vue";
import Detail from "./DetalleDespacho2.vue";
import Report from "../recepcion/Report.vue";

import axios from "axios";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

import VueNotifications from "vue-notifications";
import miniToastr from "mini-toastr";

import ExtraInfoWaybill from "./ExtraInfoWaybill";
import selectScale from "../reusable/selectScale";

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};

miniToastr.init({ types: toastTypes });

export default {
  name: "IngresoWaybillDis",
  components: {
    FormWizard,
    TabContent,
    AddPalletsGuia,
    BarcodeScanner,
    Detail,
    Report,
    ExtraInfoWaybill,
    selectScale
  },
  mounted() {
    this.waybillSaved = false;
    this.getCustomers();
    this.getPlants();

    this.waybillData.id = "";
    this.waybillData.numero_guia = "";
    this.waybillData.waybill_date = "";
    this.waybillData.arrival_datetime = "";
    this.waybillData.internal_note = "";
    this.waybillData.truck_driver = "";
    this.waybillData.note = "";
    this.waybillData.license_plate = "";
    this.waybillData.plant = "";
    this.waybillData.client_customer = "";
    this.waybillData.company = this.$store.state.user.DETAILS.id;

    if (this.waybillID != null) {
      this.loadWaybill(this.waybillID);
      this.waybillSaved = true;
      this.getPalletWaybill();
    }

    this.$barcodeScanner.destroy();
  },
  props: ["waybillID"],
  data() {
    return {
      waybill: null,
      parent: "",
      validated: false,
      tableDataPalletGuia: [],
      tableDataPalletStock: [],
      kilosBrutosTotales: 0,
      kilosNetosTotales: 0,
      submitStatus: null,
      selected: null, // Must be an array reference!
      waybillSaved: false,
      formModal: {
        status: false, //False to hide, True to show.
        type: false //False if is a new content, True if there is an axistind content and require edition.
      },
      show: true,
      items: [],
      counter: 0,
      // contentEdit is the object selected in child component. Look for props in DetallesRecepcion.vue. There has to be passed to DetalleRecepcionModal.vue, the other child component.
      contentEdit: {},
      waybillData: {
        id: "",
        numero_guia: "",
        waybill_date: "",
        arrival_datetime: "",
        internal_note: "",
        note: "",
        license_plate: "",
        plant: "",
        truck_driver: "",
        company: this.$store.state.user.DETAILS.id,
        recipient_company: null,
        client_customer: "",
        client: "",
        texto_exportadora: ""
      },
      extraInfoWaybillObj: {
        shipping_number: "",
        container_number: ""
      },
      companies: [],
      plantOptions: [],
      customers: [],
      fields: [
        { key: "numero", label: "#" },
        { key: "pallet_number", label: "Número", sorteable: true },
        { key: "product_name", label: "Producto", sorteable: true },
        { key: "product_type_name", label: "Tipo", sorteable: true },
        { key: "variety_name", label: "Variedad", sorteable: true },
        { key: "origin_name", label: "Origen", sorteable: true },
        { key: "condition", label: "Condicion", sorteable: true },
        { key: "container_name", label: "Formato/Recip", sorteable: true },
        { key: "quantity", label: "Cantidad", sorteable: true },
        { key: "net_kilograms", label: "Kg Netos", sorteable: true },
        { key: "pallet_dispatch_weight", label: "Peso Pallet", sorteable: true },
        { key: "actions", label: " ", sorteable: true }
      ],
      showModalExtraInfo: false
    };
  },
  mixins: [validationMixin],
  validations: {
    waybillData: {
      client_customer: {
        required
      },
      recipient_company: {
        required
      },
      numero_guia: {
        required,
        numeric
      },
      waybill_date: {
        required
      },
      truck_driver: {
        required
      },
      license_plate: {
        required
      },
      plant: {
        required
      }
    }
  },
  computed: {},
  watch: {
    "waybillData.client_customer": {
      handler(val) {
        this.getCompanies(this.waybillData.client_customer);
      }
    }
  },
  methods: {
    getCompleteWaybill(a) {
      this.$axios
        .get("/api/v1/waybill/" + a + "/waybill_complete/")
        .then((res) => {
          this.waybill = res.data;
        })
        .catch((error) => console.log(error));
    },
    getContents(a) {
      this.$axios
        .get("/api/v1/waybill/" + a + "/waybill_content/")
        .then((res) => {
          // console.log(res)
          const data = res.data;
          const items = [];
          for (let key in data) {
            const item = data[key];
            items.push(item);
          }
          this.items = items;
        })
        .catch((error) => console.log(error));
      this.$refs.addPallet.table.refresh();
    },
    addPalletswaybill() {
      this.getContents(this.waybillData.id);
    },
    deletePallet(row) {
      this.tableDataPalletStock.push(row);
      let deleteIndex = this.tableDataPalletGuia.findIndex((item) => item.id_pallet === row.pallet);
      this.tableDataPalletGuia.splice(deleteIndex, 1);

      const palletData = {
        id_pallet: row.pallet
      };

      this.$axios
        .put("/production/delete_pallet_guia", palletData)
        .then((res) => {})
        .catch((error) => console.log(error));
      this.updateKilosTabla();
      this.getContents(this.waybillData.id);
    },
    excludePallet(row) {
      this.$axios
        .put("/api/v1/pallet/" + row.pallet + "/exclude_pallet_from_dispatch_waybill/")
        .then((res) => {
          this.getContents(this.waybillData.id);
          this.$refs.addpallet.$refs.table.refresh();
        })
        .catch((error) => console.log(error));
    },
    updateKilosTabla: function () {
      this.kilosBrutosTotales = 0;
      this.kilosNetosTotales = 0;

      for (var indice in this.tableDataPalletGuia) {
        this.kilosBrutosTotales += parseFloat(this.tableDataPalletGuia[indice].Kilos_brutos);
        this.kilosNetosTotales += parseFloat(this.tableDataPalletGuia[indice].Kilos_netos);
      }

      return true;
    },
    onComplete() {
      this.submitWaybill();
      // this.$v.$touch()
      // if (this.$v.$invalid) {
      //   this.submitStatus = 'ERROR'
      //     console.log('Error')
      // } else {
      //    console.log('BIEN')
      //   // do your submit logic here
      //   this.submitStatus = 'PENDING'
      //   setTimeout(() => {
      //     this.submitStatus = 'OK'
      //   }, 500)
      // }
    },
    loadWaybill(a) {
      axios
        .get("/api/v1/waybill/" + a + "/")
        .then((res) => {
          this.waybillData.id = res.data.id;
          this.waybillData.numero_guia = res.data.number;
          this.waybillData.waybill_date = res.data.waybill_date;
          this.waybillData.arrival_datetime = res.data.arrival_datetime;
          this.waybillData.internal_note = res.data.internal_note;
          this.waybillData.plant = res.data.plant;
          this.waybillData.truck_driver = res.data.truck_driver;
          this.waybillData.note = res.data.note;
          this.waybillData.license_plate = res.data.license_plate;
          this.waybillData.client_customer = { id: res.data.client_customer, text: res.data.client_customer_name };
          // this.getCompanies(res.data.client_customer);
          // this.getCompaniesEdit(res.data.company, res.data.company_name);
          this.waybillData.recipient_company = res.data.recipient_company;
          this.waybillData.client = res.data.client;

          this.loadExtaInfoWaybill(a);
        })
        .catch((error) => console.log(error));
    },
    loadExtaInfoWaybill(a) {
      axios
        .get(`/api/v1/extra-info-waybill/get_extra_info_waybill/?w=${a}`)
        .then((res) => {
          if (res.data.status == 1) {
            this.extraInfoWaybillObj.shipping_number = res.data.data.shipping;
            this.extraInfoWaybillObj.container_number = res.data.data.container;
          }
        })
        .catch((error) => console.log(error));
    },
    getCompanies(a) {
      this.$axios
        .get("/production/get_companies/" + this.waybillData.client_customer.id + "/")
        .then((res) => {
          const data = res.data.data;
          const companies = [];
          for (let key in data) {
            const company = data[key];
            companies.push(company);
          }
          this.companies = companies;
        })
        .catch((error) => console.log("Error"));
    },
    getPlants() {
      this.$axios
        .get("/production/get_plants/")
        .then((res) => {
          const data = res.data.data;
          const companies = [];
          for (let key in data) {
            const company = data[key];
            companies.push(company);
          }
          this.plantOptions = companies;
        })
        .catch((error) => console.log("Error"));
    },
    getCompaniesEdit(id, texto) {
      axios
        .get("/production/get_companies/" + this.waybillData.client_customer.id + "/")
        .then((res) => {
          const data = res.data.data;
          const companies = [];
          this.waybillData.company = "";

          for (let key in data) {
            const company = data[key];
            companies.push(company);
          }
          this.companies = companies;

          this.waybillData.recipient_company = { id: id, text: texto };
        })
        .catch((error) => console.log("Error"));
    },
    getCustomers() {
      axios
        .get("/production/get_customers/")
        .then((res) => {
          const data = res.data.data;
          const customers = [];

          //customers.push({ value: null, text: "Seleccione" });

          for (let key in data) {
            const customer = data[key];
            customers.push(customer);
          }

          this.customers = customers;
        })
        .catch((error) => console.log(errors));
    },
    getPalletWaybill() {
      axios
        .get("/api/v1/allstock/" + this.waybillID + "/getAllInfoPalletGuia/")
        .then((res) => {
          const data = res.data.data;

          if (res.data.status == 1) {
            for (let key in data) {
              var rowNew = {
                Numero: data[key].number,
                Kilos_brutos: data[key].total_gross_kilograms,
                Kilos_netos: data[key].total_net_kilograms,
                id_pallet: data[key].id,
                total_contents: data[key].total_contents,
                contents_data: data[key].contents
              };
            }
            this.addPalletswaybill(rowNew);
          }
        })
        .catch((error) => console.log(errors));
    },
    openEditModal(data) {
      this.contentEdit = data;
      // Set formModal.type to true to tell the modal that is a update modal.
      this.formModal.type = true;
      // Use ref to run child methods.
      this.$refs.modals.loadEdit(data);
      this.formModal.status = true;
    },
    changeVerification: async () => {
      const formData = {
        number: parent.waybillData.numero_guia,
        waybill_date: parent.waybillData.waybill_date,
        arrival_datetime: null,
        internal_note: parent.waybillData.internal_note,
        note: parent.waybillData.note,
        license_plate: parent.waybillData.license_plate,
        plant: parent.waybillData.plant,
        truck_driver: parent.waybillData.truck_driver,
        company: parent.waybillData.company,
        recipient_company: parent.waybillData.recipient_company,
        client_customer: parent.waybillData.client_customer.id,
        waybill_type: 1,
        client: parent.$store.getters.user.ID_CLIENTE
      };

      if (parent.waybillSaved === false) {
        try {
          const res = await parent.$axios
            .post("/api/v1/waybill/", formData)
            .then((res) => {
              miniToastr.success("Guía creada con éxito", "");
              parent.waybillData.id = res.data.id;
              parent.waybillSaved = true;
              parent.validated = true;

              parent.addInfoExtra(1);
            })
            .catch(function (error) {
              parent.$swal.fire(error.response.data.non_field_errors[0], "", "warning");

              parent.validated = false;
            });
        } catch (err) {
          console.error("error" + err);
        }
      } else {
        try {
          const res = await parent.$axios
            .put("/api/v1/waybill/" + parent.waybillData.id + "/", formData)
            .then((res) => {
              miniToastr.success("Guía actualizada con éxito", "");
              parent.waybillData.id = res.data.id;
              parent.validated = true;
              parent.addInfoExtra(2);
            })
            .catch(function (error) {
              parent.$swal.fire(error.response.data.non_field_errors[0], "", "warning");

              parent.validated = false;
            });
        } catch (err) {
          console.error("erroor" + err);
        }
      }

      return parent.validated;
    },
    submitWaybill() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
        //  console.log('ERROR')

        this.$swal.fire("Campos requeridos o invalidos en el formulario", "", "warning");

        return false;
      } else {
        parent = this;

        return this.changeVerification();
      }
    },
    addInfoExtra(tipo) {
      //create
      if (tipo == 1) {
        //guarda informacion extra de la guia

        let formData = {
          waybill_id: this.waybillData.id,
          shipping_number: this.extraInfoWaybillObj.shipping_number,
          container_number: this.extraInfoWaybillObj.container_number
        };

        this.$axios
          .post("/api/v1/extra-info-waybill/save_extra_info_waybill/", formData)
          .then((res) => {})
          .catch(function (error) {
            this.$swal.fire(error.response.data.non_field_errors[0], "", "warning");
          });
      }

      //update
      if (tipo == 2) {
        //guarda informacion extra de la guia

        let formData = {
          waybill_id: this.waybillData.id,
          shipping_number: this.extraInfoWaybillObj.shipping_number,
          container_number: this.extraInfoWaybillObj.container_number
        };

        this.$axios
          .put("/api/v1/extra-info-waybill/update_extra_info_waybill/", formData)
          .then((res) => {})
          .catch(function (error) {
            this.$swal.fire(error.response.data.non_field_errors[0], "", "warning");
          });
      }
    },
    tapSiguiente() {
      if (this.items && this.items.length) {
        this.getCompleteWaybill(this.waybillData.id);
        return true;
      } else {
        this.$swal.fire("Debe agregar por lo menos un pallet en la guia", "", "warning");

        return false;
      }
    },
    tapTerminar() {
      this.$swal
        .fire({
          title: "Seguro que quieres realizar esta operación?",
          text: "",
          type: "warning",
          showCancelButton: true,
          cancelButtonText: "No",
          confirmButtonText: "Sí"
        })
        .then((result) => {
          if (result.value) {
            const result = this.changeVerification();
            if (result) {
              this.$swal.fire("Despacho concluido con exito", "", "success");
              this.$router.push("/despacho/listado");
            }
            return true;
          }
        });

      return false;
    }
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
